<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <div class="flex justify-content-between">

          <div class="flex flex_gap_10">
            <div class="form-group">
              <label for="">Препарат</label>
              <input type="text" v-model="filter.d" placeholder="Наименование препарата" class="form-control">
            </div>
            <div class="form-group">
              <label for="">Статус</label>
              <select v-model="filter.s" class="form-control">
                <option value="-1">Все статусы</option>
                <option v-for="(s, id) in statuses" :value="id">{{ s.title }}</option>
              </select>
            </div>
          </div>
          <LoadingButton
            title='Показать'
            :loading="loading"
            :color="$constants.PRIMARY_COLOR"
            :onClick="() => getRecords()"
            className="btn btn-outline-info"
          />
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
        <div v-if="!loading">
          <table class="table m-0 table-sm table-hover">
            <tbody>
            <tr v-for="(r,i) in records">
              <td>{{ (i + 1) + ((paginator?.current_page ?? 1) - 1) * (paginator?.per_page ?? 1) }}</td>
              <td>{{ r?.related_ms_drug?.title }}</td>
              <td>
                <p v-if="r.task_data?.comment">{{ r.task_data.comment }}</p>
                <div>
                  <div v-for="(c, ii) in (r.task_data?.report?.comments ?? [])"
                       :class="{'border-top': ii > 0 }">
                    <p>{{ c.text }}</p>
                    <p class="text-muted text-right">{{ printDate(c.created_at) }}</p>
                  </div>
                </div>
              </td>
              <td>
                <button class="btn btn-outline-info"
                        @click="mixinOpenDrawer({type: 'drugTasks003', task: {...r,task_data: {...r.task_data}}})">
                  <i class="icon-fa icon-fa-eye"></i>
                </button>
              </td>
              <td>
                <p><span
                  :class="{badge: true, [statuses[r.status]?.class]: true}">{{ statuses[r.status]?.title }}</span></p>
                <p>{{ printDate(r.created_at, 'DD.MM.YYYY') }}</p>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="text-right">
          <paginate v-if="paginator"
                    v-model="paginator.current_page"
                    :page-count="paginator.last_page"
                    ref="Pagination"
                    :page-range="11"
                    :margin-pages="2"
                    :click-handler="getRecords"
                    :prev-text="'&laquo'"
                    :next-text="'&raquo'"
                    :container-class="'pagination'"
                    :prev-class="'page-item'"
                    :prev-link-class="'page-link'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'"
                    :next-class="'page-item'"
                    :next-link-class="'page-link'"
                    :active-class="'active green_btn'">
          </paginate>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import api from "@/api";
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import Paginate from 'vuejs-paginate'

export default {
  components: {LoadingButton, Paginate},
  title: 'Прозвон',
  data() {
    return {
      tasksType: 22, //outsource_store_call
      loading: false,
      paginator: null,
      statuses: {
        0: {title: 'открыта', class: 'badge-warning'},
        1: {title: 'модерация', class: 'badge-danger'},
        2: {title: 'закрыта', class: 'badge-success'},
        5: {title: 'в работе', class: 'badge-warning'},
        6: {title: 'отложенная', class: 'badge-info'},
      },
      records: [],
      filter: {
        d: '',
        s: -1,
      },
    }
  },
  created() {
    this.getRecords()
  },
  methods: {
    async getRecords(page = 1) {
      this.loading = true;
      const filter = new URLSearchParams({...this.filter, page: page});
      let {data: r_data} = await api.index('/tasks/type/' + this.tasksType + '?' + filter);
      const {data, ...pagination} = r_data.records;
      this.paginator = pagination;
      this.records = data;
      this.loading = false;
    }
  }
}

</script>
